module.exports = " <a href=\"$RegisterLink\" class=\"register-cta\">Register</a>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/templates/register-link.html
// module id = 444
// module chunks = 1